import {
  Button,
  Chip,
  customScrollMinimal,
  SkeletonLoader,
  typographyV2,
} from '@toggle/design-system';
import styled from 'styled-components';

export const Root = styled.div`
  border-radius: 8px;
  border: 1px solid var(--border-soft);
  background: var(--surface-default);
`;

export const Row = styled.div`
  display: flex;
  padding: 12px 16px;
  align-items: flex-end;
  justify-content: space-between;
  gap: 8px;
`;

export const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const TitleLabel = styled.div`
  ${typographyV2.titleBase};
`;

export const DescriptionLabel = styled.div`
  ${typographyV2.bodySm};
  color: var(--text-soft);
`;

export const StyledButton = styled(Button)`
  width: fit-content;
  flex-shrink: 0;
`;

export const StyledLoader = styled(SkeletonLoader).attrs({
  areas: [
    {
      styles: {
        width: '100%',
        height: '128px',
        borderRadius: '8px',
      },
    },
  ],
})``;

export const ScrollableList = styled.div`
  ${customScrollMinimal};
  max-height: 300px;
  overflow-y: auto;
`;

export const CustomHeaderLabel = styled.div`
  ${typographyV2.bodyXs};
  color: var(--text-soft);
  padding: 0 16px 8px 16px;
  text-transform: uppercase;
`;

export const Separator = styled.div`
  height: 1px;
  margin: 8px 0;
  background: var(--border-soft);
`;

export const StyledChip = styled(Chip)`
  background-color: var(--surface-soft);
  border: 1px solid var(--border-default);
`;
